mutation UpdateMyDisplayName($name: String!) {
  displayName: StreamToolsUpdateMyDisplayName(name: $name) {
    name
  }
}
